import React from 'react';
import {
    useParams,
    useLocation,
} from 'react-router-dom';
import loadable from '@loadable/component';
import PocTabs from '../../Components/PocTabs/PocTabs';
import { getSportDefaultTabs } from '../../Components/PocTabs/Utils/Context';
import { getSportNameBySlug } from '../../../shared/utils/sportsbook';
import { getUpcomingMatchesLayoutKey } from '../../../shared/components/react/FeaturedMatchesWidget/utils';
import i18n from '../../../shared/utils/i18n';
import { GENERIC_SPORTS_HEADER } from './constants';
import BetFeedWidget from '~scenes/betfeed/widget';
import InplayWidget from '~scenes/inplaywidget';
import LongArticleWidget from '~scenes/LongArticleWidget';

const FeaturedMatchesWidget = loadable(
    () => import(/* webpackChunkName: "featured-matches-widget" */ '../../../shared/components/react/FeaturedMatchesWidget/FeaturedMatchesWidget')
);

const InplayEventsCounterButton = loadable(
    () => import(/* webpackChunkName: "inplay-events-counter-button" */ './Components/InplayEventsCounterButton/InplayEventsCounterButton')
);

const Homepage = () => {
    const { sportSlug } = useParams();
    const { state: {context: { originalUrl: [ localizedSportSlug ] } } } = useLocation();

    const gtmAttribute = sportSlug + GENERIC_SPORTS_HEADER;

    const sportName = getSportNameBySlug(sportSlug);

    const featuredMatchesWidgetProps = {
        layout: getUpcomingMatchesLayoutKey(),
        sport: sportSlug,
        widgetHeader: i18n.t('sports.upcoming_matches'),
        source: sportSlug,
    };

    return (
        <React.Fragment key={sportSlug}>
            <PocTabs
                tabs={getSportDefaultTabs(sportSlug, localizedSportSlug)}
                gtmAttribute={gtmAttribute}
            />
            <InplayWidget
                sport={sportSlug}
                source={sportSlug}
            />

            {
                sportName &&
                <BetFeedWidget
                    sportSlug={sportSlug}
                    sportName={sportName}
                />
            }

            <InplayEventsCounterButton
                sportSlug={sportSlug}
                localizedSportSlug={localizedSportSlug}
            />
            <LongArticleWidget sportSlug={sportSlug} gtmCategory={sportSlug} gtmAction='Longform-Article' />
            <FeaturedMatchesWidget {...featuredMatchesWidgetProps} />
        </React.Fragment>
    );
};

export default Homepage;
